import React, {Component, ReactElement} from "react";
import Table, { TableColumn } from "../Table";
import {CommandBarButton, TextField, ActionButton} from "office-ui-fabric-react";
import TableCell from "../TableCell";

export interface MailroomExcludeEditorProps {
    onChange(newItems: string[]): void;
    items: string[];
    disabled: boolean;
    title: string;
    header: string;
}

export interface MailroomExcludeEditorState {
    options: {item: string}[];
    newItem: string;
}

export class MailroomExcludeEditor extends Component<MailroomExcludeEditorProps, MailroomExcludeEditorState>
{
    constructor(props: MailroomExcludeEditorProps) {
        super(props);

        this.state = {
            options: [],
            newItem: ""
        };
    }

    private static readonly columns: TableColumn[] = [
        { title: "Items", propertyPath: "item", enableSort: true, flex: 4 },
        { title: "", propertyPath: "remove", enableSort: false, flex: 1 },
    ];

    public async componentDidMount() {
        this.setSubjectCodeOptions();
    }

    componentDidUpdate(prevProps: Readonly<MailroomExcludeEditorProps>, prevState: Readonly<MailroomExcludeEditorState>, snapshot?: any): void {
        
        if(this.props.items !== prevProps.items)
        {
            this.setSubjectCodeOptions();
        }
    }
    
    private setSubjectCodeOptions()
    {
        const options = this.props.items.map(value => {
            return {item: value}
        });
        this.setState({
            options
        });
    }
    
    private addNewItem(newItem: string) {
        if(!newItem)
        {
            return;
        }

        const sanitisedNewItem = this.state.newItem.toLowerCase().trim();

        if(!sanitisedNewItem || this.state.options.map(sco => sco.item).indexOf(sanitisedNewItem) !== -1)
        {
            return;
        }

        const newItems = [...this.props.items];
        newItems.push(sanitisedNewItem);
        this.setState({
            newItem: ""
        });

        this.props.onChange(newItems);
    }

    private removeItem(itemToRemove: string) {
        
        const indexOfItem = this.props.items.indexOf(itemToRemove);
        const newItems = [...this.props.items];
        newItems.splice(indexOfItem,1);
        this.props.onChange(newItems);
    }
    
    private cellForColumn = (option: {item: string}, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {
        
        if(column.propertyPath === "remove")
        {
            return (
                <ActionButton iconProps={{iconName: "Remove"}} title="Remove" ariaLabel="Remove" disabled={this.props.disabled} onClick={() => {
                    this.removeItem(option.item)
                }}>
                    Remove
                </ActionButton>
            );
        }
    }
    
    public render() {
        return (
            <Table 
                title={this.props.title}
                className={"cdb-table--no-margin-sides"}
                columns={MailroomExcludeEditor.columns}
                items={this.state.options}
                enableSort={true}
                cellForColumn={this.cellForColumn}>
                
                <div className={"flex-row flex--align-items-center"}>
                    <TextField
                        className="flex-item--flex-1 m-right-1rem"
                        value={this.state.newItem}
                        placeholder={this.props.header}
                        disabled={this.props.disabled}
                        onChange={(e: any) => {
                            this.setState({
                                newItem: e.target.value
                            });
                        }
                        } />

                    <CommandBarButton
                        iconProps={{iconName: "Add"}}
                        disabled={this.props.disabled}
                        text={"Add"}
                        onClick={() => {
                            this.addNewItem(this.state.newItem);
                        }}
                    />
                </div>
            </Table>
        );
    }
}